import { useNavigate } from "react-router-dom"
import { Helmet } from "react-helmet"

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>404 Not Found</title>
      </Helmet>
      <div className="min-h-[75vh] w-full px-4 sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-3xl flex-col items-center justify-center py-14 text-center">
          {/* Image */}
          <img
            src="/images/assets/404_NOT_FOUND-V1.webp"
            alt="No data illustration"
            className="mb-2 w-full max-w-sm sm:max-w-md"
          />

          <p className="max-w-xl text-gray-600">
            The page you’re looking for doesn’t exist or may have been moved.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <button
              className="rounded-xl bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800"
              onClick={(e) => {
                e.preventDefault()
                navigate(-1)
              }}
            >
              Go back
            </button>
            <button className="rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50">
              Contact support
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
